export enum InvoiceStatus {
  PAID = 1,
  DECLINED = 2,
  REPORTED = 3,
  OVERDUE = 4,
  ISSUE_RESOLVED = 5,
  NOT_PAID = 9,
}
